<template>
    <!-- Summary cards (Count, In payment, paid, sum) -->
    <div
        v-if="deliveries.length > 0"
        class="d-flex mb-3"
        style="gap: 1rem; flex-wrap: wrap;"
    >
        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('common.total') }}</div>
                <div class="h2 mb-0">{{ Math.round(weights.count * 10) / 10 }} t ({{ totals.count }})</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('delivery_note.statuses.in_delivery') }}</div>
                <div class="h2 mb-0 text-info">{{ Math.round(weights.inDelivery * 10) / 10}} t ({{ totals.inDelivery }})</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('delivery_note.statuses.unloading') }}</div>
                <div class="h2 mb-0 text-warning">{{ Math.round(weights.unloading * 10) / 10 }} t ({{ totals.unloading }})</div>
            </div>
        </div>

        <div class="card p-3 stat-card">
            <div class="text-left">
                <div class="small text-muted mb-2">{{ $t('delivery_note.statuses.unloaded') }}</div>
                <div class="h2 mb-0 text-success">{{ Math.round(weights.unloaded * 10) / 10 }} t ({{ totals.unloaded }})</div>
            </div>
        </div>

    </div>
</template>

<script>

import {deliveryStatus} from "../mixins/DeliveryNoteMixin.js";

export default {
    name: 'MaterialStatusSummary',
    mixins: [deliveryStatus],
    data()  {
        return {
            totals: { count: 0, inDelivery: 0, unloading: 0, unloaded: 0},
            weights: { count: 0, inDelivery: 0, unloading: 0, unloaded: 0},
            selectedStatus: null
        }
    },
    props: {
        deliveries: {type: Array, default: []}
    },
    watch: {
        deliveries() {
            this.updateSummary()
        }
    },
    mounted() {
       this.updateSummary()
    },
    methods: {
        updateSummary() {
            const totalsTemp = { count: 0, inDelivery: 0, unloading: 0, unloaded: 0 }
            const weightsTemp = { count: 0, inDelivery: 0, unloading: 0, unloaded: 0 }
            if (this.deliveries) {
                this.deliveries.forEach(delivery => {
                    const weight = delivery.unit === 't' ? delivery.amount : delivery.unit === 'kg' ? Math.round(delivery.amount / 100) / 10 : 0
                    totalsTemp.count++
                    weightsTemp.count += weight
                    if (delivery.status === deliveryStatus.IN_DELIVERY) {
                        totalsTemp.inDelivery++
                        weightsTemp.inDelivery += weight
                    } else if (delivery.status === deliveryStatus.UNLOADING) {
                        totalsTemp.unloading++
                        weightsTemp.unloading += weight
                    } else if (delivery.status === deliveryStatus.UNLOADED) {
                        totalsTemp.unloaded++
                        weightsTemp.unloaded += weight
                    }
                })
            }
            this.totals = totalsTemp
            this.weights = weightsTemp
        }
    }
}

</script>

<style scoped>
.card { background: #fff; border: 1px solid #e6e6e6; border-radius: 4px; }

.stat-card {
    border-radius: 12px;
    border: 1px solid #e0e0e0;
   flex: 1 1 0;
    min-width: 200px;
}

</style>
